import styled from 'styled-components';

export const ToolbarUploadingSpinner = styled.span`
  position: absolute;
  top: 50%;
  right: ${({theme}) => theme.getSize(2)};
  transform: translateY(-50%);
  display: flex;
  align-items: center;
`;
